import moment from 'moment';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { Button, notification } from 'antd';
import './cardScreening.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import {
  CheckCircleOutlined,
  FieldTimeOutlined,
  LockOutlined,
  SendOutlined,
  PushpinOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { CiViewTable } from 'react-icons/ci';
import Progress from '../Progress/Progress';
import { t } from '../../i18n/i18n';
import CopyCheck from '../../assets/search/Check';
import CopyLink from '../../assets/search/Link';
import DeleteForever from '../../assets/screening/DeleteForever';
import DuplicateEvaluation from '../DuplicateEvaluation/DuplicateEvaluation';
import useModalDetails from '../../hooks/useModalDetails';
import Modal from '../Modal/Modal';
import ArrowInvite from '../../assets/screeningSearchs/ArrowInvite';
import ModalDeleteDraft from './ModalDeleteDraft';
import VerticalDotsDropdown from '../VerticalDotsDropdown/VerticalDotsDropdown';
import DeleteIcon from '../../assets/profile/Delete';
import EditPencilIcon from '../../assets/common/EditPencilIcon';
import People from '../../assets/screeningSearchs/People';
import StatsIcon from '../../assets/screeningSearchs/StatsIcon';
import useSearchDashboard from '../../hooks/useSearchDashboard';
import CalendarClose from '../../assets/screeningSearchs/CalendarClose';
import useClickOutside from '../../hooks/useClickOutside';
import ArchiveBoxIcon from '../../assets/screeningSearchs/ArchiveBoxIcon';
import {
  getStageScreening,
  updatePinnedRecruitSessions,
  updateProctoringEnabledRecruitSessionStage,
} from '../../API/services/screeningService';
import { disableForWorkspaceRole } from '../../utils/workspaceRoleValidation';
import { editSearchStage, reOpenEvaluation } from '../../API/services/companyService';
import {
  determineDisabledFeature,
  determineDisabledMinimumTier,
} from '../../utils/determineDisabled';
import {
  CustomFeatureEnum,
  PartnerWorkspaceRole,
  PlanFeaturesIds,
  ReviewTypeEnum,
} from '../../constants/enums';
import CameraProctoringEnabled from '../../assets/screeningSearchs/CameraProctoringEnabled';
import CameraProctoringDisabled from '../../assets/screeningSearchs/CameraProctoringDisabled';
import { ModalProctoringEnabled } from './ModalProctoringEnabled';
import InfoIcon from '../../assets/search/InfoIcon';
import MoveScreeningIcon from '../../assets/screeningSearchs/MoveScreeningIcon';
import ModalMoveScreening from './ModalMoveScreening';
import { getLocalStorageWorkspace } from '../../utils/workspaceUtils';
import PencilDraft from '../../assets/screening/PencilDraft';
import Reopen from '../../assets/screening/Reopen';
import CountryFlag from '../CountryFlag/CountryFlag';
import { useLanguageTranslations } from '../../hooks/useLanguageTranslations';
import { TrackEventGTM } from '../../utils/filters/analyticsUtils';
import { CREATE_EVALUATION } from '../../constants/routes';
import { EventsGTM } from '../../constants/events';
import { shareRecruitSessionToHiringRoom } from '../../API/services/alkymersService';
import { isAlkemyEmail } from '../../utils/emailsUtils';
import useRoles from '../../hooks/useRoles';

const CardScreeningSearch = ({
  data,
  fetchDraft,
  reloadSearches,
  setSearchesQuantity,
  onPinChange,
  pinnedCount,
}) => {
  const { user, currentRole, currentWorkspace } = useSelector((state) => state.auth);
  const { roles, loadRoles, isRole } = useRoles();
  const history = useHistory();
  const { languagesList } = useLanguageTranslations();
  const isCardScreeningSearch = true;
  const { handleScreeningModalData, screeningModalContent, closeModal, loadingModal, showModal } =
    useModalDetails();
  const { showConfirmationModal, setShowConfirmationModal, confirmCloseSearchModalContent } =
    useSearchDashboard(data.recruitSessionId, isCardScreeningSearch, reloadSearches);
  const cardRef = useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showProctoringEnabledModal, setShowProctoringEnabledModal] = useState(false);
  const [proctoringDataModal, setProctoringDataModal] = useState({
    proctoringEnabled: false,
    recruitSessionStageId: '',
  });
  const [showMoveScreeningModal, setShowMoveScreeningModal] = useState(false);
  const [moveScreeningDataModal, setMoveScreeningDataModal] = useState({
    partnerId: '',
    recruitSessionStageId: '',
  });
  const [reOpenLoading, setReOpenLoading] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [publicIdCopySuccess, setPublicIdCopySuccess] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [disabledWorkspaceFunctions, setDisabledWorkspaceFunctions] = useState(true);
  const [pinned, setPinned] = useState(false);
  const [hiringRoomSharedEvaluation, setHiringRoomSharedEvaluation] = useState(false);
  const [changingReviewType, setChangingReviewType] = useState(false);
  const [localReviewType, setLocalReviewType] = useState(data?.reviewType);
  const hiringRoomIntegrated =
    user?.companyCustomFeatures?.customFeatures?.some(
      (cf) => cf?.featureEnum === CustomFeatureEnum.HIRING_ROOM
    ) && user?.companyCustomFeatures?.workspaceId === currentWorkspace;
  const isAlkemyUser = isAlkemyEmail(user?.email);

  useEffect(() => {
    loadRoles();
    setDisabledWorkspaceFunctions(
      disableForWorkspaceRole(currentRole, [
        PartnerWorkspaceRole.OWNER,
        PartnerWorkspaceRole.ADMINISTRATOR,
      ])
    );
  }, []);

  useEffect(() => {
    setLocalReviewType(data?.reviewType);
  }, [data?.reviewType]);

  useClickOutside(cardRef, () => setOpenDropdown(false));

  const today = new Date();
  const searchIsFinish = new Date(data.recruitSessionStageEndDate) < today;
  moment.locale('es');

  const progressBars = [
    {
      percent: ((data.createdAccounts * 100) / data.invitationsSent).toFixed(0),
      value: `${data.createdAccounts}/${data.invitationsSent}`,
      translate: t('CREATED_ACCOUNTS'),
      visible: true,
    },
    {
      percent: ((data.totalPrefiltered * 100) / data.invitationsSent).toFixed(0),
      value: `${data.totalPrefiltered}/${data.invitationsSent}`,
      translate: t('SCREENINGS_PREFILTERED'),
      visible: data?.prefilterId ?? false,
    },
    {
      percent: ((data.evaluationsStarted * 100) / data.invitationsSent).toFixed(0),
      value: `${data.evaluationsStarted}/${data.invitationsSent}`,
      translate: t('SCREENINGS_STARTED'),
      visible: true,
    },
    {
      percent: ((data.evaluationsFinished * 100) / data.invitationsSent).toFixed(0),
      value: `${data.evaluationsFinished}/${data.invitationsSent}`,
      translate: t('SCREENINGS_FINISHED'),
      visible: true,
    },
  ];

  const copyLink = () => {
    navigator.clipboard.writeText(data.invitationLink);
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 1000);
  };

  const editStage = () => {
    history.push(
      `/search/${data.recruitSessionId}?editDates=1?editName=1&workspaceId=${currentWorkspace}`
    );
  };

  const goToSearchStats = () => {
    history.push(
      `/search/${data.recruitSessionId}?stats=${data.recruitSessionStageId}&workspaceId=${currentWorkspace}`
    );
  };

  const openModalForShowTests = async () => {
    const stage = await getStageScreening({
      companyId: getLocalStorageWorkspace()?.companyId,
      levelId: data.screeningId,
    });
    handleScreeningModalData(stage.id);
  };

  const closeEvaluation = () => {
    setOpenDropdown(false);
    setShowConfirmationModal(true);
  };

  const setProctoringShowModal = ({ proctoringEnabled, recruitSessionStageId = '' }) => {
    setOpenDropdown(false);
    setShowProctoringEnabledModal(true);
    setProctoringDataModal({
      proctoringEnabled,
      recruitSessionStageId,
    });
  };

  const setMoveScreeningModal = (pId, data) => {
    setOpenDropdown(false);
    setShowMoveScreeningModal(true);
    setMoveScreeningDataModal({
      partnerId: pId,
      id: data.isDraft ? data.id : data.recruitSessionStageId,
      isDraft: data.isDraft,
    });
  };

  const onClickProctoringToggle = () => {
    updateProctoringEnabledRecruitSessionStage(proctoringDataModal.recruitSessionStageId, {
      proctoringEnabled: !proctoringDataModal.proctoringEnabled,
    })
      .then(() => {
        setShowProctoringEnabledModal(false);
        reloadSearches();
      })
      .catch(() => {
        setShowProctoringEnabledModal(false);
      });
  };

  const deleteDraft = () => {
    setOpenDropdown(false);
    setShowDeleteModal(true);
  };

  const handleReOpenEvaluation = async (recruitSessionId) => {
    setOpenDropdown(false);
    setReOpenLoading(true);
    await reOpenEvaluation(recruitSessionId);
    reloadSearches();
  };

  const copyStagePublicId = async () => {
    await navigator.clipboard.writeText(data.recruitSessionStagePublicId);
    setPublicIdCopySuccess(true);
    setTimeout(() => {
      setPublicIdCopySuccess(false);
    }, 1000);
  };

  const goToSearch = () => {
    if (data.isDraft) {
      TrackEventGTM(EventsGTM.CLICK_CREATE_EVALUATION, {
        event_category: 'CardScreeningSearch',
        event_label: 'Edit Draft Button',
        event_action: 'click',
        draft_id: data.id,
      });
    }
    history.push(
      data.isDraft
        ? `${CREATE_EVALUATION}?draftId=${data.id}`
        : `/search/${data.recruitSessionId}?workspaceId=${currentWorkspace}`
    );
  };

  const sharedAssessmentToHiringRooom = async () => {
    try {
      setHiringRoomSharedEvaluation(true);
      const expired =
        new Date(
          user?.companyCustomFeatures?.customFeatures?.find(
            (i) => i.featureEnum === CustomFeatureEnum.HIRING_ROOM
          )?.authentication?.expiresAt
        ) < new Date();
      if (expired) {
        // Redirect to integrations page when token is expired
        notification.open({
          message: t('MUST_REFRESH_TOKEN'),
          type: 'warning',
        });
        history.push('/integrations');
        return;
      }
      await shareRecruitSessionToHiringRoom({
        stageId: data.recruitSessionStageId,
      });
      notification.open({
        message: t('ASSESSMENT_SHARED_TO_HIRING_ROOM'),
        type: 'success',
      });
    } catch (e) {
      console.error('Error sharing assessment to Hiring Room:', e);
      notification.open({
        message: t('ERROR'),
        type: 'error',
        description: t('FAILED_TO_SHARE_ASSESSMENT'),
      });
    } finally {
      setHiringRoomSharedEvaluation(false);
    }
  };

  const handleChangeReviewType = async () => {
    setOpenDropdown(false);
    setChangingReviewType(true);
    const newReviewType =
      localReviewType === ReviewTypeEnum.PSYCHOTECHNICS
        ? ReviewTypeEnum.GLOBAL
        : ReviewTypeEnum.PSYCHOTECHNICS;
    try {
      await editSearchStage(data.recruitSessionStageId, {
        reviewType: newReviewType,
      });
      setLocalReviewType(newReviewType);
      notification.success({
        message: t('REVIEW_TYPE_UPDATED_SUCCESS'),
        duration: 3,
      });
      reloadSearches();
    } catch (error) {
      notification.error({
        message: t('ERROR'),
        description: error?.response?.data?.message || 'Error inesperado',
        duration: 3,
      });
    } finally {
      setChangingReviewType(false);
    }
  };

  const dropdownOptions = [
    {
      icon: <EditPencilIcon className="icon" fill="#757575" width="14" height="14" />,
      text: t('EDIT'),
      disabled: false,
      action: () => (data.isDraft ? goToSearch() : editStage()),
      itemClass: `dropdown-option ${!data.isActive && !data.isDraft && 'd-none'}`,
      testid: 'edit-button',
    },
    {
      customContent: (
        <DuplicateEvaluation
          screeningId={data.screeningId || data.id}
          name={data.isDraft ? data.name : data.recruitSessionStageName}
          isDraft={data.isDraft}
          disabled={disabledWorkspaceFunctions}
          isDropdown
        />
      ),
      itemClass: 'dropdown-option',
      testid: 'duplicate-button',
    },
    {
      icon: <EditPencilIcon className="icon" fill="#757575" width="14" height="14" />,
      text: t('RE_OPEN'),
      disabled: false,
      action: () => handleReOpenEvaluation(data.recruitSessionId),
      itemClass: `dropdown-option ${
        data.isActive || new Date() > new Date(data.recruitSessionStageEndDate) || data?.isDraft
          ? 'd-none'
          : ''
      }`,
      testid: 'edit-pencil-button',
    },
    {
      icon: <DeleteIcon className="icon" />,
      text: t('DELETE_TOOLTIP'),
      disabled: false,
      action: () => deleteDraft(),
      itemClass: `dropdown-delete-option ${!data.isDraft && 'd-none'}`,
      testid: 'delete-button',
    },
    {
      icon: <People className="icon" />,
      text: t('VIEW_CANDIDATES'),
      disabled: false,
      action: () => goToSearch(),
      itemClass: `dropdown-option ${
        (data.isDraft ||
          Number(data.invitationsSent) === 0 ||
          (Number(data.createdAccounts) === 0 && !data.isActive)) &&
        'd-none'
      }`,
      testid: 'view-candidates-button',
    },
    {
      icon: <StatsIcon className="icon" width="14" height="16" />,
      text: t('VIEW_STATS'),
      disabled: false,
      action: () => goToSearchStats(),
      itemClass: `dropdown-option ${
        (data.isDraft || Number(data.invitationsSent) === 0) && 'd-none'
      }`,
      testid: 'view-stats-button',
    },
    {
      icon: data.proctoringEnabled ? (
        <CameraProctoringDisabled className="icon" />
      ) : (
        <CameraProctoringEnabled className="icon" />
      ),
      text: data.proctoringEnabled
        ? t('DISABLED_PROCTORING_DROPDOWN')
        : t('ENABLED_PROCTORING_DROPDOWN'),
      disabled: false,
      action: () =>
        setProctoringShowModal({
          proctoringEnabled: data.proctoringEnabled,
          recruitSessionStageId: data.recruitSessionStageId,
        }),
      itemClass: `dropdown-option `,
      testid: 'proctoring-enabled-button',
    },
    {
      icon: searchIsFinish ? (
        <ArchiveBoxIcon className="icon" />
      ) : (
        <CalendarClose className="icon" />
      ),
      text: searchIsFinish ? t('SCREENING_DASHBOARD_FINISH_SEARCH') : t('FINISH_EVALUATION'),
      disabled: false,
      action: () => closeEvaluation(),
      itemClass: `${searchIsFinish ? 'dropdown-option' : 'dropdown-delete-option'} ${
        (data.isDraft || !data.isActive) && 'd-none'
      }`,
      testid: 'close-search-button',
    },
    {
      icon: <MoveScreeningIcon />,
      text: t('MOVE_WORKSPACE_MENU'),
      disabled: false,
      action: () => setMoveScreeningModal(user.id, data),
      itemClass: `${disabledWorkspaceFunctions ? 'd-none' : 'dropdown-option'}`,
      testid: 'move-search-icon',
    },
    {
      icon: publicIdCopySuccess ? <CopyCheck /> : <CopyLink height="16" />,
      text: publicIdCopySuccess ? t('COPIED_INVITATION_LINK') : t('COPY_PUBLIC_ID_LABEL'),
      disabled: determineDisabledMinimumTier(2) || !data.recruitSessionStagePublicId,
      action: () => copyStagePublicId(),
      itemClass: 'dropdown-option',
      testid: 'public-id-copy-icon',
    },
    {
      icon: hiringRoomSharedEvaluation ? <LoadingOutlined /> : <SendOutlined />,
      text: hiringRoomSharedEvaluation ? t('SHARING_HIRING_ROOM') : t('SHARED_HIRING_ROOM'),
      disabled: determineDisabledMinimumTier(2) || !hiringRoomIntegrated,
      action: () => sharedAssessmentToHiringRooom(),
      itemClass: `dropdown-option ${!hiringRoomIntegrated && 'd-none'}`,
      testid: 'share_test_hr_icon',
    },
    {
      icon: changingReviewType ? (
        <LoadingOutlined />
      ) : (
        <EditPencilIcon className="icon" fill="#757575" width="14" height="14" />
      ),
      text:
        localReviewType === ReviewTypeEnum.PSYCHOTECHNICS
          ? t('CHANGE_TO_GLOBAL')
          : t('CHANGE_TO_PSYCHOTECHNICS'),
      disabled: !isAlkemyUser || changingReviewType || data.isDraft,
      action: () => handleChangeReviewType(),
      itemClass: `dropdown-option ${!isAlkemyUser && 'd-none'}`,
      testId: 'change-review-type-button',
    },
    {
      icon: changingReviewType ? (
        <LoadingOutlined />
      ) : (
        <EditPencilIcon className="icon" fill="#757575" width="14" height="14" />
      ),
      text:
        localReviewType === ReviewTypeEnum.PSYCHOTECHNICS
          ? t('CHANGE_TO_GLOBAL')
          : t('CHANGE_TO_PSYCHOTECHNICS'),
      disabled: changingReviewType || data.isDraft || !isRole(roles.PSYCHOTECHNICALCREATOR),
      action: () => handleChangeReviewType(),
      itemClass: `dropdown-option ${!isRole(roles.PSYCHOTECHNICALCREATOR) && 'd-none'}`,
      testId: 'change-review-type-button',
    },
  ];

  const searchStatus = () => {
    if (data.isDraft) return { label: t('SCREENING_SEARCH_DRAFT'), icon: <PencilDraft /> };
    if (!data.isActive) return { label: t('SEARCH_INACTIVE'), icon: <LockOutlined /> };
    if (searchIsFinish)
      return {
        label: t('SEARCH_EXPIRED'),
        description: t('SEARCH_FINISH_DESCRIPTION'),
        icon: (
          <FieldTimeOutlined style={{ color: '#686868', strokeWidth: 10 }} className="icon-check" />
        ),
      };
    if (new Date(data.recruitSessionStageStartDate) > today) return t('SEARCH_SHEDULED');
    return {
      label: t('SEARCH_ACTIVE'),
      icon: (
        <CheckCircleOutlined style={{ color: '#4987be', strokeWidth: 10 }} className="icon-check" />
      ),
    };
  };

  const setBgColor = () => {
    if (data.isDraft) return 'draft-bg';
    if (!data.isActive) return 'closed-bg';
    if (searchIsFinish) return 'closed-bg';
    return 'open-bg';
  };

  const setTextColor = () => {
    if (data.isDraft) return '#686868';
    if (!data.isActive) return '#272727';
    if (searchIsFinish) return '#272727';
    return '#4987be';
  };

  const [flipped, setFlipped] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    timeoutRef.current = setTimeout(() => setFlipped(true), 1000);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeoutRef.current);
    setFlipped(false);
  };

  const handlePinned = async () => {
    try {
      const updatedWorkspace = await updatePinnedRecruitSessions({
        partnerId: user.id,
        pinnedRecruitSessions: [data.recruitSessionId],
      });
      setPinned(!pinned);
      notification.success({
        message: pinned ? t('SEARCH_UNPINNED') : t('SEARCH_PINNED'),
        duration: 3,
      });
      if (onPinChange) {
        if (pinned) {
          onPinChange('unpin', data.id, updatedWorkspace);
        } else {
          onPinChange('pin', data.id, updatedWorkspace);
        }
      }
    } catch {
      notification.error({
        message: t('ERROR_PINNING_SEARCH'),
        duration: 3,
      });
    }
  };

  useEffect(() => {
    if (user && user.workspaces) {
      const partnerToWorkspace = user.workspaces.find(
        (workspace) => workspace.workspaceId === currentWorkspace
      );
      if (partnerToWorkspace) {
        const isPinned = partnerToWorkspace.pinnedRecruitSessions?.includes(data.recruitSessionId);
        setPinned(isPinned);
      }
    }
  }, [user, currentWorkspace, data.id]);

  return (
    <div
      ref={cardRef}
      data-testid="card-screening-search"
      className="col col-12 col-md-6 col-xl-4 p-0 card-height p-2"
    >
      <Modal
        show={showModal}
        relativeCloseButton
        className="rounded px-4 py-2 justify-content-center w-80vw"
        showCloseButton={!loadingModal}
        closeBtnClassname="text-blue-principal font-weight-bold"
        setShow={(e) => closeModal(e)}
      >
        {screeningModalContent()}
      </Modal>
      <ModalDeleteDraft
        showDeleteModal={showDeleteModal}
        user={user}
        partnerId={data?.partner?.id}
        setShowDeleteModal={setShowDeleteModal}
        draftId={data.id}
        fetchDrafts={fetchDraft}
        setSearchesQuantity={setSearchesQuantity}
      />
      <Modal
        show={showConfirmationModal}
        className="close-search-modal-container"
        closeBtnClassname="text-blue-principal font-weight-bold"
        setShow={setShowConfirmationModal}
        showCloseButton={false}
      >
        {confirmCloseSearchModalContent()}
      </Modal>
      <ModalProctoringEnabled
        setShowModal={setShowProctoringEnabledModal}
        showModal={showProctoringEnabledModal}
        data={proctoringDataModal}
        submitAction={onClickProctoringToggle}
        disabledButtonProps
      />
      <ModalMoveScreening
        setShowModal={setShowMoveScreeningModal}
        showModal={showMoveScreeningModal}
        data={moveScreeningDataModal}
        reloadSearches={reloadSearches}
      />
      <div className="h-100 m-0  d-flex flex-column screening-search-container bg-white">
        <div className="b-radius-8 d-flex h-100 flex-column justify-content-center">
          <div
            className={`px-2 screening-title-container d-flex justify-content-between align-items-center ${setBgColor()}`}
          >
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="" placement="top">
                  {data?.isDraft ? data.name : data.recruitSessionStageName}
                </Tooltip>
              }
            >
              <Link
                data-testid="name-button"
                rel="noreferrer noopener"
                to={
                  data.isDraft
                    ? `${CREATE_EVALUATION}?draftId=${data.id}`
                    : `/search/${data.recruitSessionId}?workspaceId=${currentWorkspace}`
                }
                onClick={() => {
                  if (data.isDraft) {
                    TrackEventGTM(EventsGTM.CLICK_CREATE_EVALUATION, {
                      event_category: 'CardScreeningSearch',
                      event_label: 'Draft Title Link',
                      event_action: 'click',
                      draft_id: data.id,
                    });
                  }
                }}
                className="text-decoration-none text-left border-0 bg-transparent overflow-hidden text-truncate font-weight-600 text-sm title-screening description-card-search"
                style={{ whiteSpace: 'nowrap' }}
              >
                {data.isDraft ? data?.name : data?.recruitSessionStageName}
              </Link>
            </OverlayTrigger>
            <div className="d-flex">
              <OverlayTrigger
                placement="top"
                overlay={
                  searchStatus().description ? (
                    <Tooltip className="" placement="top">
                      {searchStatus().description}
                    </Tooltip>
                  ) : (
                    <div />
                  )
                }
              >
                <div className="d-flex px-2 align-items-center gap-1 text-xs font-weight-600">
                  <span style={{ color: setTextColor() }}>
                    {searchStatus().label?.toUpperCase()}
                  </span>
                  <span className="d-flex align-items-center mr-2">{searchStatus().icon}</span>
                </div>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip className="">
                    {pinned ? t('CARD_SCREENING_SEARCH_UNPIN') : t('CARD_SCREENING_SEARCH_PIN')}
                  </Tooltip>
                }
              >
                <Button
                  className="d-flex align-items-center bg-transparent border-0 mr-3"
                  onClick={handlePinned}
                  disabled={!pinned && pinnedCount >= 6}
                >
                  <PushpinOutlined className={`icon-pin ${pinned ? 'pinned' : ''}`} />
                </Button>
              </OverlayTrigger>
            </div>
            <span className="position-dots">
              <VerticalDotsDropdown
                options={dropdownOptions}
                className="mr-2 width-selectable"
                setOpenDropdown={setOpenDropdown}
                openDropdown={openDropdown}
                disabled={disabledWorkspaceFunctions}
              />
            </span>
          </div>
          <div className="d-flex mb-3 icons-position align-items-center" />
          <div
            className={`card-screenings ${flipped && 'flipped'}`}
            onClick={() => !data.isDraft && setFlipped(!flipped)}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className="card-front-screenings"
              onMouseEnter={() => !data.isDraft && handleMouseEnter}
            >
              <div className="d-flex align-items-center gap-2">
                {!data.isDraft && (
                  <div className="align-items-center justify-content-center">
                    {data?.evaluationsPendingCredits > 0 && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip className="">{t('EVALUATIONS_PENDING_CREDITS')}</Tooltip>}
                      >
                        <div>
                          <a
                            className="text-xs diamond-background d-flex align-items-center justify-content-center rounded-circle"
                            href={process.env.RAZZLE_RUNTIME_SALES_CALENDAR_URL}
                          >
                            <InfoIcon color="#ff7676" />
                          </a>
                        </div>
                      </OverlayTrigger>
                    )}
                  </div>
                )}
                <div className="d-flex flex-column w-100">
                  {!data.isDraft ? (
                    progressBars.map((pb) => (
                      <div key={pb.translate} className={`mb-2 text-xs ${!pb.visible && 'd-none'}`}>
                        <span className=" font-weight-400 mb-2 color-grey-1">
                          <span className="mr-2 font-weight-600">{pb.translate}</span>
                          {pb.value}
                        </span>
                        <Progress
                          percent={pb.percent}
                          barColor="linear-gradient(90deg, #59C2F2 0%, #9AF45C 100%)"
                        />
                      </div>
                    ))
                  ) : (
                    <div className="d-flex flex-column">
                      <div className="d-flex text-xs text-weight-600 justify-content-between border-bottom-dotted">
                        <span>{t('CREATE_SCREENING_SELECTED_TESTS')}</span>
                        <span>{`${data?.testGroupList?.length} ${t(
                          'CREATE_EVALUATION_TESTS_TITLE'
                        )}`}</span>
                      </div>
                      <div className="d-flex text-xs text-weight-600 justify-content-between border-bottom-dotted">
                        <span>{t('CREATE_SCREENING_SELECTED_TESTS')}</span>
                        <span>{`${data?.customTestGroup?.tests?.length ?? 0} ${t(
                          'QUESTIONS'
                        )?.toLowerCase()}`}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-back-screenings text-xs font-weight-600 d-flex flex-column gap-1 pt-0">
              <div className="d-flex justify-content-between border-bottom-dotted">
                <span>{t('SCREENING_INVITATIONS_SENT')}</span>
                <span>{`${data.invitationsSent} ${t('SCREENING_GUESTS')}`}</span>
              </div>
              <div className="d-flex justify-content-between border-bottom-dotted">
                <span>{t('SCREENING_COMPLETED_LABEL')}</span>
                <span>{`${data.evaluationsFinished} ${t('SCREENING_COMPLETED_TIMES_LABEL')}`}</span>
              </div>
              <div className="d-flex justify-content-between border-bottom-dotted">
                <span>{t('DASHBOARD_SEARCH_HEADERS_LIMIT_DATE')}</span>
                <span>
                  {data.recruitSessionStageEmptyDates
                    ? t('SCREENING_NO_LIMIT_DATE')
                    : moment(data.recruitSessionStageEndDate).format('D MMM YYYY')}
                </span>
              </div>
            </div>
          </div>

          <div className="d-flex position-relative w-100 justify-content-between pb-1 px-2 mt-3">
            {(data?.partner?.firstName || data?.partnerFirstName) && (
              <span
                data-testid="span-created-by"
                className="mt-auto  text-muted text-xs font-weight-400 overflow-hidden text-truncate italic px-2"
              >
                {`${t('RECRUIT_SESSION_DRAFT_CREATED_BY')} ${
                  data.isDraft
                    ? ` ${data?.partner?.firstName} ${data?.partner?.lastName}`
                    : ` ${data?.partnerFirstName} ${data?.partnerLastName}`
                }`}
              </span>
            )}
            {Boolean(data?.isActive) &&
              Boolean(Number(data.invitationsSent) === 0) &&
              new Date(data.recruitSessionStageEndDate) > today && (
                <span
                  data-testid="arrow-invite-span"
                  className="mr-2 d-flex align-items-center h-100"
                >
                  <ArrowInvite />
                </span>
              )}
            <span className="font-weight-400 italic text-xs text-muted px-2 text-truncate">
              {moment(data.recruitSessionStageStartDate).format('D MMM YYYY')}
            </span>
          </div>
        </div>
        <div
          data-testid="footer-card"
          className="mt-auto footer-card d-flex justify-content-between"
        >
          <div className="d-flex justify-content-center w-100 gap-1">
            {data.isDraft || new Date(data.recruitSessionStageEndDate) < today || !data.isActive ? (
              <>
                {data.isDraft ? (
                  <div className="d-flex gap-2">
                    <button
                      onClick={() => {
                        goToSearch();
                      }}
                      className="text-xs font-weight-600 bg-transparent d-flex align-items-center border-0 bg-white text-underline gap-1"
                      type="button"
                    >
                      <span className="">{t('EDIT')}</span>
                      <EditPencilIcon fill="#357b9eff" width={15} height={16} />
                    </button>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip className="">{t('DELETE_TOOLTIP')}</Tooltip>}
                    >
                      <button
                        disabled={disabledWorkspaceFunctions}
                        className="border-0 outline-none bg-transparent ml-2 d-flex align-items-center gap-1"
                        type="button"
                        data-testid="delete-draft-button"
                        onClick={() => {
                          deleteDraft();
                        }}
                      >
                        <span className="text-xs font-weight-600 bg-transparent d-flex align-items-center border-0 bg-white text-underline">
                          {t('DELETE_TOOLTIP')}
                        </span>
                        <span className="d-flex align-items-center">
                          <DeleteForever fill="#357b9eff" width={15} height={16} />
                        </span>
                      </button>
                    </OverlayTrigger>
                  </div>
                ) : (
                  <div className="d-flex gap-2">
                    <div className="d-flex align-items-center">
                      <button
                        onClick={() => {
                          handleReOpenEvaluation(data.recruitSessionId);
                        }}
                        className="text-xs font-weight-600 bg-transparent d-flex align-items-center border-0 bg-white text-underline gap-1"
                        type="button"
                        disabled={reOpenLoading}
                      >
                        <span className="">{t('RE_OPEN')}</span>
                        <span>
                          <Reopen />
                        </span>
                      </button>
                    </div>
                    <DuplicateEvaluation
                      screeningId={data.screeningId || data.id}
                      name={data.isDraft ? data.name : data.recruitSessionStageName}
                      isDraft={data.isDraft}
                      disabled={disabledWorkspaceFunctions}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    openModalForShowTests();
                  }}
                  className="text-xs font-weight-600 bg-transparent d-flex align-items-center border-0 bg-white text-underline gap-1"
                  type="button"
                >
                  {t('VIEW_SCREENING_TEST')}
                  <span>
                    <CiViewTable />
                  </span>
                </button>
                <button
                  disabled={disabledWorkspaceFunctions}
                  data-testid="copy-link-button"
                  type="button"
                  className={` text-xs font-weight-600 d-flex align-items-center gap-1 border-0 bg-transparent text-underline ${
                    determineDisabledFeature({ featureId: PlanFeaturesIds.SEARCH_LINKS })
                      ? 'displayNone'
                      : ''
                  }`}
                  onClick={() => {
                    TrackEventGTM(EventsGTM.EVALUATION_COPY_LINK, {
                      event_category: 'Copy evaluation link from card',
                      event_label: 'Copy Link',
                      event_action: 'click',
                      draft_id: data.id,
                    });
                    copyLink();
                  }}
                >
                  {copySuccess ? (
                    <span className="d-flex gap-1">
                      {t('COPIED_INVITATION_LINK')}
                      <CopyCheck />
                    </span>
                  ) : (
                    <span className="d-flex gap-1">
                      {t('COPY_INVITATION_LINK')}
                      <CopyLink width="12" height="12" />
                    </span>
                  )}
                </button>
                <div className={data.language ? '' : 'd-none'}>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip placement="top">{t('SCREENING_LANGUAGE_SET')}</Tooltip>}
                  >
                    <span>
                      <CountryFlag
                        className="mx-1"
                        size="sm"
                        countryIso={languagesList.find((l) => l.value === data.language)?.iso}
                      />
                    </span>
                  </OverlayTrigger>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardScreeningSearch;
